import { render } from "./BackByRoute.vue?vue&type=template&id=a83c437c&ts=true"
import script from "./BackByRoute.vue?vue&type=script&lang=ts"
export * from "./BackByRoute.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__